import http from "./http";
import {LoginInfoEntity} from "../entity/login-info-entity";
import {BaseLibraryEntity} from "../entity/base-library-entity";
import {SpecimenEntity} from "../entity/specimen-entity";
import {TreeData} from "../entity/tree-data";
import {ResPage} from "./interface";
import {ImageInfoEntity} from "../entity/image-info-entity";
import {AtlasEntity} from "../entity/atlas-entity";
import {MenuInfoEntity} from "../entity/menu-info-entity";

// 登录接口
export const loginApi = (params: any) => {
    return http.post("/user/login", params);
}

// 获取用户列表
export const getUserInfoList = (params: any) => {
    return http.get<ResPage<LoginInfoEntity>>("/user/getUserInfo", params);
}

// 更改用户启用停用状态
export const changeUserStatusApi = (params: any) => {
    return http.get("/user/enableUser", params);
}

// 重置密码
export const resetUserPassword = (params: any) => {
    return http.get("/user/resetPwd", params);
}

// 删除用户
export const deleteUserApi = (params: any) => {
    return http.get("/user/deltUser",params);
}

// 新增用户
export const addUserApi = (params:any) => {
    return http.post("/user/addUser", params);
}

//编辑用户
export const editUserApi = (params:any) => {
    return http.post("/user/editUser", params);
}

// 重置用户密码
export const resetUsePasswordApi = (params: any) => {
    return http.get("/user/resetPwd", params);
}

// 获取基础库信息
export const getBaseLibraryInfoApi = (params: any) => {
    return http.get<ResPage<BaseLibraryEntity>>("/baselibrary/getManagerBaseLibraryInfo", params);
}

// 删除基础库信息
export const deleteBaseLibraryInfoApi = (params: any) => {
    return http.get("/baselibrary/delBaseLibrary", params);
}

// 编辑基础库信息
export const editBaseLibraryInfoApi = (params: any) => {
    return http.post("/baselibrary/editBaseLibrary", params);
}
// 上传标本excel
export const uploadSpecimenExcelApi = (params: any) => {
    return http.post("/specimen/uploadExcel", params, {'Content-type' : 'multipart/form-data'});
}

// 上传标本图片
export const uploadSpecimenPictureApi = (params: any) => {
    return http.post("/upload/upload_images", params, {'Content-type' : 'multipart/form-data'});
}

// 删除标本信息
export const deleteSpecimenInfoApi = (params: any) => {
    return http.get("/specimen/delSpecimen", params);
}
//获取标本列表信息
export const getSpecimenListApi = (params: any) => {
    return http.get<ResPage<SpecimenEntity>>("/specimen/getManagerSpecimenInfo", params);
}
// 新增标本信息
export const addSpecimenInfoApi = (params: any) => {
    return http.post("/specimen/addSpecimen", params);
}
export const editSpecimenInfoApi = (params: any) => {
    return http.post("/specimen/editSpecimen", params);
}

export const uploadBaseLibraryExcel = (params: any) => {
    return http.post("/baselibrary/uploadExcel", params, {'Content-type' : 'multipart/form-data'})
}

export const getWaterMarkImage = (params: any) => {
    return http.get("/specimen/download", params);
}

// 获取原植物图库
export const getImageInfo = (params: any) => {
    return http.get<ResPage<ImageInfoEntity>>("/image/getImageInfo", params);
}

// 获取系统信息数据接口
export const getManagerSystemInfo = (params: any) => {
    return http.get("/systeminfo/getManagerSystemInfo", params);
}

// 添加系统信息数据接口
export const addSystemInfo = (params: any) => {
    return http.post("/systeminfo/addSystemInfo", params);
}

// 编辑系统信息数据接口
export const editSystemInfo = (params: any) => {
    return http.post("/systeminfo/editSystemInfo", params);
}

// 删除系统信息数据接口
export const delSystemInfo = (params: any) => {
    return http.post("/systeminfo/delSystemInfo", params);
}

export const getBaseTreeApi = (params:any) => {
    return http.get<TreeData[]>("/baselibrary/getManagerBaseLibraryTree", params);
}

// 获取图谱库列表
export const getManagerAtlasInfoList = (params: {}) => {
    return http.get<ResPage<AtlasEntity>>("/atlas/getManagerAtlasInfo", params)
}

// 图谱库批量导入功能
export const uploadAtlasExcel = (params: any) => {
    return http.post("/atlas/uploadExcel", params, {'Content-type' : 'multipart/form-data'})
}

// 删除图谱库数据
export const deleteAtlasRecord = (params: {}) => {
    return http.get("/atlas/delAtlasInfo", params);
}
// 新增图谱库数据
export const addAtlasInfo = (params: any) => {
    return http.post("atlas/addAtlasInfo", params)
}

// 编辑图谱数据
export const editAtlasInfo = (params: any) => {
    return http.post("/atlas/editAtlasInfo", params)
}

// 获取dna序列库列表
export const getManagerDnaInfoList = (params: {}) => {
    return http.get<ResPage<AtlasEntity>>("/dna/getManagerDnaInfo", params)
}

// dna序列库批量导入功能
export const uploadDnaExcel = (params: any) => {
    return http.post("/dna/uploadExcel", params, {'Content-type' : 'multipart/form-data'})
}

// 删除dna序列库数据
export const deleteDnaRecord = (params: {}) => {
    return http.get("/dna/delDnaInfo", params);
}
// 新增dna序列库数据
export const addDnaInfo = (params: any) => {
    return http.post("/dna/addDnaInfo", params)
}

// 编辑dna序列数据
export const editDnaInfo = (params: any) => {
    return http.post("/dna/editDnaInfo", params)
}

// 获取原植物图库数据接口
export const getManagerImageInfo = (params: any) => {
    return http.get("/image/getManagerImageInfo", params)
}

// 添加原植物图库数据接口
export const addImageInfo = (params: any) => {
    return http.post("/image/addImageInfo", params)
}

// 删除原植物图库数据接口
export const delImageInfo = (params: any) => {
    return http.post("/image/delImageInfo", params)
}

// 编辑原植物图库数据接口
export const editImageInfo = (params: any) => {
    return http.post("/image/editImageInfo", params)
}

// 上传图片
export const uploadImages = (params: any) => {
    return http.post("/upload/upload_images", params)
}

// 原植物图库批量上传
export const uploadOriginalExcel = (params: any) => {
    return http.post("/image/uploadExcel", params, {'Content-type' : 'multipart/form-data'})
}

// 添加关于我们
export const addAboutUsInfo = (params: any) => {
    return http.post("/aboutus/addAboutUsInfo", params)
}

// 获取关于我们
export const getManagerAboutUsInfo = (params: any) => {
    return http.get("/aboutus/getManagerAboutUsInfo", params)
}

// 编辑关于我们
export const editAboutUsInfo = (params: any) => {
    return http.post("/aboutus/editAboutUsInfo", params)
}

// 获取科普宣传
export const getManagerPopularInfo = (params: any) => {
    return http.get("/popluar/getManagerPopularInfo", params)
}

// 添加科普宣传
export const addPopular = (params: any) => {
    return http.post("/popluar/addPopular", params)
}

// 编辑科普宣传
export const editPopular = (params: any) => {
    return http.post("/popluar/editPopular", params)
}
// 科普宣传状态切换
export const offPopular = (params: any) => {
    return http.get("/popluar/offPopular", params)
}

// 删除科普宣传
export const delPopular = (params: any) => {
    return http.get("/popluar/delPopular", params)
}

// 获取菜单列表
export const getMenuList = (params: {}) => {
    return http.get<MenuInfoEntity[]>("/menu/getMenuInfo", params)
}

// 封面和用户头像上传
export const uploadPopular = (params: any) => {
    return http.post("/upload/upload_popular", params)
}

// 获取评论列表
export const getManagerCommentInfo = (params: {}) => {
    return http.get("/comment/getManagerCommentInfo", params)
}

// 删除评论
export const delCommentInfo = (params: {}) => {
    return http.get("/comment/delCommentInfo", params)
}

// 置顶评论  1 置顶 0 不置顶  id 评论id
export const toCommentTop = (params: {}) => {
    return http.post("/comment/to_top", params)
}

// 获取阅读排行榜
export const getStatReadOrder = (params: {}) => {
    return http.get("/read/getStatReadOrder", params)
}

// 获取统计数
export const getStatTotal = (params: {}) => {
    return http.get("/stat/getStatTotal", params)
}

// dna序列分类
export const getStatDna = (params: {}) => {
    return http.get("/stat/getStatDna", params)
}

// 图库库分类
export const getStatAtlas = (params: {}) => {
    return http.get("/stat/getStatAtlas", params)
}

// 标本来源
export const getStatSpecimen = (params: {}) => {
    return http.get("/stat/getStatSpecimen", params)
}

// 原植物图库分类
export const getStatPlantImage = (params: {}) => {
    return http.get("/stat/getStatPlantImage", params)
}

// 词云
export const getStatSearchFreq = (params: {}) => {
    return http.get("/stat/getStatSearchFreq", params)
}
 
// 系统记录变化趋势  startTime和endTime
export const getStatTrend = (params: {}) => {
    return http.get("/stat/getStatTrend", params)
}
 
// 漏斗图
export const getStatFgs = (params: {}) => {
    return http.get("/stat/getStatFgs", params)
}
 
// 漏斗图
export const getCommentInfo = (params: {}) => {
    return http.get("/comment/getCommentInfo", params)
}
 
// 修改用户密码   // useraccount password newpwd
export const editPwd = (params: {}) => {
    return http.post("/user/editPwd", params)
}